import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { IconDotsMenuVertical } from 'components/Icons';
import { Popover } from 'components/Popover';
import { PopoverDisclosure, usePopoverState } from 'reakit/Popover';
import { Button } from 'components/ui_library/Button';
import { css, cx } from '@linaria/core';
interface ActionListProps {
  name?: string;
  actions?: React.ReactNode[];
  contextMenuActions?: React.ReactNode[];
  isButton?: boolean;
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}
export const ActionList = ({
  name,
  actions,
  contextMenuActions = [],
  isButton = true,
  children,
  className,
  dataTestId
}: ActionListProps) => {
  const popover = usePopoverState({
    placement: 'bottom-start'
  });
  const defaultDataTestId = name ? `action-list-menu--${name}` : 'action-list-menu';
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true); // To ensure document.body can be accessed safely
  }, []);
  if (!hasMounted) {
    return null;
  }

  // Abort actions if they are not valid JSX (would crash)
  if (actions && Array.isArray(actions) && actions.some(a => !(React.isValidElement(a) || typeof a === 'string' || typeof a === 'number' || a == null))) {
    return null;
  }
  return <div className={cx(actionListStyles.actionList, className)} data-testid={dataTestId ?? defaultDataTestId}>
      {children}
      {actions}
      {contextMenuActions?.length > 0 && <>
          <PopoverDisclosure {...popover}>
            <Button size="md" className={actionListStyles.menuButton} data-testid={dataTestId ?? defaultDataTestId} aria-label="open actions menu" variant={isButton ? 'tertiary' : 'unstyled'}>
              <IconDotsMenuVertical size={18} />
            </Button>
          </PopoverDisclosure>
          {ReactDOM.createPortal(<Popover aria-label="actions menu" popover={popover} className={actionListStyles.popoverWrapper}>
              <div className={actionListStyles.menuContent}>{contextMenuActions}</div>
            </Popover>, document.body)}
        </>}
    </div>;
};
const actionListStyles = {
  actionList: "omponents__ActionList__ActionList_tsx-actionList-a1x31huk",
  menuButton: "omponents__ActionList__ActionList_tsx-menuButton-mq7lcoc",
  menuContent: "omponents__ActionList__ActionList_tsx-menuContent-mztdaxl",
  popoverWrapper: "omponents__ActionList__ActionList_tsx-popoverWrapper-pcacftz"
};

require("./ActionList.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ActionList.tsx");